import { PaymentMethodImage, PaymentMethodImageTypeProps } from '@mews/business-components';
import { AssetLoader } from '@mews/framework';

interface PaymentMethodIconProps {
    type: PaymentMethodImageTypeProps['type'];
    small?: boolean;
}

const paymentMethodIconLoader = new AssetLoader({ assetDirectory: 'images' });
paymentMethodIconLoader.initialize().catch((error) => {
    throw error;
});

export const PaymentMethodIcon = (props: PaymentMethodIconProps) => {
    const { isInitialized } = paymentMethodIconLoader;

    return isInitialized ? <PaymentMethodImage assetLoader={paymentMethodIconLoader} {...props} /> : null;
};
